import { render, staticRenderFns } from "./UsersItem.vue?vue&type=template&id=6efbc498&scoped=true&"
import script from "./UsersItem.vue?vue&type=script&lang=js&"
export * from "./UsersItem.vue?vue&type=script&lang=js&"
import style0 from "./UsersItem.vue?vue&type=style&index=0&id=6efbc498&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efbc498",
  null
  
)

component.options.__file = "UsersItem.vue"
export default component.exports